import SidebarLayout from "components/organisms/SidebarLayout";

export const ProductNotFoundPathname = "/product-not-found/";

const ProductNotFound = () => {
    return <SidebarLayout content={<p>Oops, we couldn't load that product.</p>} />;
};

export default ProductNotFound;
